(() => {
  const normalize = value => String(value || '').normalize('NFKC').trim().toLowerCase().replace(/[\u2010-\u2015]/g, '-');
  const barcode = value => /^\d{8,14}$/.test(String(value).replace(/[\s-]/g, '')) ? String(value).replace(/[\s-]/g, '') : '';
  function build(records) {
    const maps = {sku:new Map(),mpn:new Map(),barcode:new Map()};
    const add = (type,value,row) => {
      const key = type === 'barcode' ? barcode(value) : normalize(value);
      if (!key) return;
      if (!maps[type].has(key)) maps[type].set(key,[]);
      maps[type].get(key).push(row);
    };
    records.forEach(row => {
      add('sku',row[2],row); add('barcode',row[3],row); add('mpn',row[4],row);
      add('mpn',row[5],[null,row[1],row[2],row[3],row[4],row[5]]);
    });
    return maps;
  }
  function exact(maps,query) {
    const key=normalize(query), upc=barcode(query);
    const rows=maps.sku.get(key) || (upc && maps.barcode.get(upc)) || maps.mpn.get(key);
    if (!rows?.length || new Set(rows.map(r=>r[1])).size!==1) return null;
    const variants=[...new Set(rows.filter(r=>r[0]).map(r=>r[0]))];
    return {handle:rows[0][1],variant:variants.length===1?variants[0]:null};
  }
  const api={normalize,barcode,build,exact};
  if(typeof window!=='undefined') window.CTOReferenceCore=api;
  if(typeof module!=='undefined' && module.exports) module.exports=api;
})();
